$(function(){
    var modal = $('.age-confirm');
    var body = $('body');

    $('button.age-confirm__button').click(function(){
        modal.addClass('age-confirm--hide');
        body.removeClass('overflow--hidden');

        // Requires cookie.js
        ConfirmAge();
    });
});

function ConfirmAge() {
    Cookies.set('ageConfirmed', true, { expires: 14 });
}


// Play the video when the age check is closed
function initAgeCheckClickPlay() {

    $(function () {
        $('button.age-confirm__button').click(function () {
            playVideo();
        });
    });

}